module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "quickpass-slide",
    staticClass: "quickpass-slide"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "qs qs-1"
  }, [_c('h2', [_vm._v("付款码支付")]), _vm._v(" "), _c('p', [_vm._v("1.进入闪付页面，打开【付款】，出示给商户扫描即可完成交易。")]), _vm._v(" "), _c('p', [_vm._v("2.超过免密限额的订单需验证支付密码。")]), _vm._v(" "), _c('p', [_vm._v("3.付款码每分钟会自动更新，并会在生成之后短时间内有效，请勿泄露任何有关付款码的信息。")]), _vm._v(" "), _c('div', {
    staticClass: "phone-bg"
  }, [_c('div', {
    staticClass: "pb-left"
  }, [_c('div', {
    staticClass: "pb-pic"
  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("1")]), _vm._v("打开付款")])]), _vm._v(" "), _c('div', {
    staticClass: "pb-right"
  }, [_c('div', {
    staticClass: "pb-pic"
  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("2")]), _vm._v("出示付款码给收银员")])]), _vm._v(" "), _c('div', {
    staticClass: "triangle-right"
  }, [_c('div', {
    staticClass: "react"
  }), _vm._v(" "), _c('div', {
    staticClass: "t-r"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "yun-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "yun-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow-bottom animation_arr_bottom"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "qs qs-2"
  }, [_c('h2', [_vm._v("付款码支付")]), _vm._v(" "), _c('p', [_vm._v("1.进入闪付页面，打开【付款】，出示给商户扫描即可完成交易。")]), _vm._v(" "), _c('div', {
    staticClass: "phone-bg"
  }, [_c('div', {
    staticClass: "pb-left"
  }, [_c('div', {
    staticClass: "pb-pic"
  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("1")]), _vm._v("打开扫一扫")])]), _vm._v(" "), _c('div', {
    staticClass: "pb-right"
  }, [_c('div', {
    staticClass: "pb-pic"
  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("2")]), _vm._v("扫描商户收银码")])]), _vm._v(" "), _c('div', {
    staticClass: "triangle-right"
  }, [_c('div', {
    staticClass: "react"
  }), _vm._v(" "), _c('div', {
    staticClass: "t-r"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "yun-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "yun-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow-bottom animation_arr_bottom"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "qs qs-3"
  }, [_c('h2', [_vm._v("付款码支付")]), _vm._v(" "), _c('p', [_vm._v("1、以下商家均可使用点点闪付进行线下支付。")]), _vm._v(" "), _c('p', [_vm._v("2、请在标记有银联闪付的商户使用。"), _c('b', {
    staticClass: "b1"
  }), _c('b', {
    staticClass: "b2"
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("家乐福")])]), _vm._v(" "), _c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("全家")])]), _vm._v(" "), _c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("罗森")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("屈臣氏")])]), _vm._v(" "), _c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("711")])]), _vm._v(" "), _c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("万宁")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("汉堡王")])]), _vm._v(" "), _c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("正大广场")])]), _vm._v(" "), _c('div', {
    staticClass: "sj-box"
  }, [_c('div', {
    staticClass: "sj-icon"
  }), _vm._v(" "), _c('p', [_vm._v("大润发")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-065db556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/quickpass.vue
// module id = 186
// module chunks = 0